import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import {liteClient} from 'algoliasearch/lite'
import { algoliaAppId, algoliaApiKey, citiesSearchIndex } from '../variables'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

const object = vnObject

const createAlertForm = $('.js-create-alert-form')

if (createAlertForm.length) {
    createAlertForm.parsley().on('form:success', function () {
        createAlertForm.attr('data-success', 'true')
    })

    createAlertForm.parsley().on('form:error', function () {
        createAlertForm.attr('data-success', 'false')
    })

    createAlertForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(createAlertForm[0])
        formData.append('action', 'vn_create_alert')
        formData.append('nonce', object.nonce)

        const $form = $(this)
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')

                if (res.success ) {
                    location.reload();
                }
            },
        })
    })
}


$('.pt-my-alerts__section--title.js-section-title').click(function(){
    var parent = $(this).parent()
    if($(window).width() < 768) {
        if (parent.hasClass('pt-my-alerts__section--open')) {
            parent.find('.js-section-texts').slideUp()
            parent.removeClass('pt-my-alerts__section--open')
        } else {
            $('.pt-my-alerts__section--open').each(function() {
                $(this).find('.js-section-texts').slideUp()
                $(this).removeClass('pt-my-alerts__section--open')
            });
            parent.find('.js-section-texts').slideDown()
            parent.addClass('pt-my-alerts__section--open')
        }
    }
})

let cityAlertSearch

var check = $('.alerts-cities-search-handler')
const checkEl = document.querySelector('.alerts-cities-search-handler')
if ( checkEl ) {
    const searchClient = liteClient(algoliaAppId, algoliaApiKey)
    cityAlertSearch = autocomplete({
        container: '.alerts-cities-search-handler',
        detachedMediaQuery: 'none',
        placeholder: __('Montpellier, Aix-en-Provence...', 'vn'),
        getSources() {
            return [{
                sourceId: 'cities',
                getItems({ query }) {
                    return getAlgoliaResults({
                        searchClient,
                        queries: [
                            {
                                indexName: citiesSearchIndex,
                                query,
                            },
                        ],
                    });
                },
                templates: {
                    item({ item }) {
                        var postalCode = item.codesPostaux.substring(0, 2)
                        return `${item.nom} ( ${postalCode} )`;
                    },
                },
                onSelect: function (event) {
                    let latLng = parseFloat(event.item.latitude) + ',' + parseFloat(event.item.longitude);
                    var postalCode = event.item.codesPostaux.substring(0, 2)
                    event.setQuery( event.item.nom + ' ( ' + postalCode + ' )' );
                    $('.js-city').val( event.item.nom + ' ( ' + postalCode + ' )' )
                    $('.js-latlng').val( latLng )
                },
            }];
        },
    });
}

$('.js-radius-input').on('click', function () {
    $('.js-radius-list').slideDown()
})

$('.js-radius-item').on('click', function () {
    $('.js-radius-input').val($(this).data('value') + 'km')
    $('.js-radius-list').slideUp()
})

$(document).on('click', function(event) {
    if (!$(event.target).closest('.js-radius-input-container').length) {
        $('.js-radius-list').slideUp()
    }
});

$('.js-deactivate-alert').on('click', function () {
    var alertNumber = $(this).parent().data('number')

    const formData = new FormData(createAlertForm[0])
    formData.append('action', 'vn_deactivate_alert')
    formData.append('alert_number', alertNumber)

    const $form = $(this)
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        data: formData,
        beforeSend: () => {
        },
        processData: false,
        contentType: false,
        success: (res) => {
            if (res.success ) {
                location.reload();
            }
        },
    })
})

$('.js-activate-alert').on('click', function () {
    var alertNumber = $(this).parent().data('number')

    const formData = new FormData(createAlertForm[0])
    formData.append('action', 'vn_activate_alert')
    formData.append('alert_number', alertNumber)

    const $form = $(this)
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        data: formData,
        beforeSend: () => {
        },
        processData: false,
        contentType: false,
        success: (res) => {
            if (res.success ) {
                location.reload();
            }
        },
    })
})

$('.js-delete-alert').on('click', function () {
    var alertNumber = $(this).parent().data('number')

    const formData = new FormData(createAlertForm[0])
    formData.append('action', 'vn_delete_alert')
    formData.append('alert_number', alertNumber)

    const $form = $(this)
    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        data: formData,
        beforeSend: () => {
        },
        processData: false,
        contentType: false,
        success: (res) => {
            if (res.success ) {
                location.reload();
            }
        },
    })
})
